import { render, staticRenderFns } from "./DocumentEdit.vue?vue&type=template&id=62d64dfc&scoped=true&"
import script from "./DocumentEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentEdit.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_edit.scss?vue&type=style&index=0&id=62d64dfc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d64dfc",
  null
  
)

export default component.exports